module.exports = "/_next/static/images/ourPartnersLogo9-59b7174c3287a7d5a2f1a008b765c05b.webp";